import { render, staticRenderFns } from "./WindowsToolBar.vue?vue&type=template&id=327f045e&scoped=true"
import script from "./WindowsToolBar.vue?vue&type=script&lang=js"
export * from "./WindowsToolBar.vue?vue&type=script&lang=js"
import style0 from "./WindowsToolBar.vue?vue&type=style&index=0&id=327f045e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f045e",
  null
  
)

export default component.exports